import { AppName } from 'root-constants'

export const enum FemiFlowColor {
  PINK_LIGHT = '#ffd1e7',
  PINK = '#ffa3ce',
  GRAY_LIGHT = '#eaeaed',
  GRAY_SURFACE = '#f9f9f9',
  GRAY_DISABLED = '#999',
  CHECKBOX_BORDER = '#b1b7c0',
  GREEN = '#46c38f',
  ORANGE = '#ffc17e',
  RED = '#ff7262',
  STRIKE = '#ff797c',
}

export const enum LuvlyFlowColor {
  CORAL_DARK = '#ff7262',
  CORAL_LIGHT = 'rgba(255, 130, 118, 0.12)',
  RED = '#e74c3c',
  GRAY_MUTED = 'rgba(21, 25, 32, 0.5)',
  GRAY_BORDER = '#cacaca',
}

export type TRetentionFlowV2Config = {
  copyKey: string
  hasCancelConfirmation: boolean
  hasPlanPriceCurrency: boolean
}

export const RETENTION_FLOW_V2_CONFIGS: Partial<
  Record<AppName, TRetentionFlowV2Config>
> = {
  [AppName.FEMI]: {
    copyKey: 'retention.femi',
    hasCancelConfirmation: true,
    hasPlanPriceCurrency: false,
  },
  [AppName.LUVLY]: {
    copyKey: 'retention.luvly',
    hasCancelConfirmation: false,
    hasPlanPriceCurrency: true,
  },
}
